'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
require('react');
const components_navigation_Button_Button = require('../../navigation/Button/Button.cjs.js');
const components_marketing_ZapCard_ZapCardSteps = require('./ZapCardSteps.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("ZapCardDetails", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    grid-template-columns: 100%;
    gap: 20px;
    box-sizing: content-box;
    padding: 0 35px 20px 35px;
    max-width: 770px;
    margin: 0 auto;
  `,
  description: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.paragraph3};
    color: ${theme_Colors.Colors.GrayWarm9};
  `,
  actions: [
    react.css`
      ${styleMixins_reset.boxSizing};
      display: flex;
      gap: 20px;
      max-width: 320px;
      margin-left: auto;
      justify-content: end;
    `
  ]
});
const ZapCardDetails = (props) => {
  const target = props.detailsHrefTarget || "_self";
  const editorTarget = props.editorHrefTarget || "_self";
  return react.jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    react.jsx(components_marketing_ZapCard_ZapCardSteps.ZapCardSteps, { steps: props.steps }),
    props.children && react.jsx("div", { css: Styles.description, "data-zds": true }, props.children),
    react.jsx(
      "div",
      null,
      react.jsx(
        "div",
        { css: Styles.actions, "data-zds": true },
        props.detailsHref && react.jsx(components_navigation_Button_Button.Button, { color: "secondary", href: props.detailsHref, size: "small", target }, "See Zap details"),
        props.editorHref && react.jsx(components_navigation_Button_Button.Button, { color: "primary", hasShadow: true, href: props.editorHref, size: "small", target: editorTarget }, "Try it")
      )
    )
  );
};

exports.ZapCardDetails = ZapCardDetails;
//# sourceMappingURL=ZapCardDetails.cjs.js.map
